<template>
  <div class="bg_index">
    <!--banner-->
    <productBanner :Product="product" class="bannerFather"></productBanner>

    <!-- 技术亮点 -->
    <div class="w100 hxjs">
      <div class="other">
        <div v-for="(item,index) in cardMsg" :key="index">
          <coreCard :cardMsg="item"></coreCard>
        </div>
      </div>
    </div>

    <!-- 使用场景 -->
    <suitCase :list="suit" class="suitcase">
      <h6 class="fon-fam">交谈式语音采集场景，比如审讯、客服柜台、问诊</h6>
    </suitCase>

    <div style="background-color: white;">
      <!-- 下载彩页 -->
      <productDownload :product="download"></productDownload>
    </div>
    <!-- 商务合作 -->
    <cooperateForm class="submitform" id="submit"></cooperateForm>
    <div class="footblack" />
  </div>
</template>

<script>
import cooperateForm from '@/components/common/cooperateForm'
import suitCase from '@/components/common/suitCase'
import coreCard from '@/components/common/coreCard'
// import { BaseURL } from '@/api/http.js'
import productBanner from '@/components/common/productBanner'
import productDownload from '@/components/common/productDownload'
export default {
  data () {
    return {
      download: '彩页图',
      suit: [
        { 'img': 'images/sj/sj_cjbg_1.png', 'context': [] },
        { 'img': 'images/sj/sj_cjbg_2.png', 'context': [] }
      ],
      product: {
        'background': 'images/sj/sj_bg.png',
        'img': 'images/sj/sj_banner_cp.png',
        'h2': ['桌面式语音采集工作站SJ-DT系列'],
        'desc': ['针对公共安全领域审讯、交谈场景的桌面式', '语音采集终端及配套PC采集软件'],
        'h3': [],
        'p': ['—高级录音师', '拾音与语音采集'],
        'product': 'images/chanpin/sj.png'
      },
      cardMsg: [{
        'img': 'images/sj/sj_js_1.png',
        'h3': '指向采集，性能优良',
        'p': [],
        'li': [
          '采用阵列式麦克风技术和音频指向性采集技术，可以更好的屏蔽周围环境噪音；',
          '内置角色分离技术，支持念读和交谈等采集模式，可以把被采集人和采集人的声音隔离出两路独立音频，确保被采集人声纹数据质量；',
          '具有多级噪声抑制功能，把采集环境噪音干扰降到最低；'
        ]
      }, {
        'img': 'images/sj/sj_js_2.png',
        'h3': '多维检测，自动把关',
        'p': [],
        'li': [
          '信噪比、平均能量、截幅比、有效时长等基本检测功能一应俱全；',
          '具有语音活性检测功能，可以把静音及噪音片段自动隔离摒弃；',
          '具有语音说话人数检测功能，录音中出现多人说话会被自动摒弃；'
        ]
      }, {
        'img': 'images/sj/sj_js_3.png',
        'h3': '安全便携，易于操作',
        'p': [],
        'li': [
          '设备外观设计精美，方便携带，安全耐用；',
          '采集软件界面简洁友好，采集录音、检测、上报等操作流程清晰易用；'
        ]
      }]
    }
  },
  methods: {
  },
  components: {
    cooperateForm: cooperateForm,
    suitCase: suitCase,
    productBanner,
    coreCard,
    productDownload
  }
}
</script>

<style scoped>
.submitform {
  width: 803px;
  margin-top: 75px;
  margin-bottom: -23px;
}
.suitcase h6 {
  font-size: 22px;
  font-weight: normal;
  color: rgba(51, 51, 51, 1);
  margin-top: 60px;
  margin-bottom: -40px;
}
.footblack {
  height: 50px;
  width: 100%;
  background: rgba(248, 248, 248, 1);
}
/* 产品亮点 */
.other {
  margin: 0 auto;
  width: 1250px;
  height: 650px;
}
.other > div {
  float: left;
  margin-left: 38px;
  margin-top: 35px;
}

.other /deep/ .context {
  min-height: 250px;
}
.other /deep/ .title {
  height: 290px;
}
.other /deep/ .context .item-core {
  width: 395px;
}
.other /deep/ .context .item-core :nth-child(2) {
  width: 295px;
}
.bannerFather /deep/ .banner {
  margin-top: -75px !important ;
  margin-left: 20px !important;
}
.bannerFather /deep/ .product-h2 {
  font-size: 46px;
  width: 150%;
}
.bannerFather /deep/ .desc {
  margin-top: 23px;
  font-size: 26px;
  width: 150%;
}
.bannerFather /deep/ .desc p {
  line-height: 35px;
  width: 150%;
}
.bannerFather /deep/ .brand {
  width: 44px;
  height: 21px;
  margin-left: 0px;
  margin-top: -56px;
}
.bannerFather /deep/ .reg {
  font-size: 20px;
  margin-left: 47px;
  margin-top: -67px;
}
.bannerFather /deep/ .product-p {
  font-size: 20px;
  font-weight: bold;
  margin-top: 143px;
}
.bannerFather /deep/ .product-p :first-child {
  margin-left: 64px;
  margin-top: -25px;
  margin-bottom: 12px;
}
.bannerFather /deep/ .caiye {
  margin-top: 55px;
}
.bannerFather /deep/ .container {
  width: 1040px;
}
.bannerFather /deep/ .banner {
  width: 41%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/solution/Sj/SoundCapture.vue